<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import {PRODUCT_NAME} from '~/utils/visa/visa-const'

    @Component
    export class VisaStoreMixin extends Vue {
        get productStore() {
            return visaStore
        }

        get productRuntimeStore() {
            return visaRuntimeStore
        }

        get productType() {
            return 'visa'
        }

        get productName() {
            return PRODUCT_NAME
        }
    }

    export default VisaStoreMixin
</script>
